export interface LearningResource {
  id: string
  title: string
  description: string
  unavailableDescription?: string
  image: string
  destination: 'routine' | 'dropbox' | 'chat'
}

export const learningResources: LearningResource[] = [
  {
    id: 'routine',
    title: 'Tu Rutina-ah!',
    description:
      'Accede a tu material de trabajo y continúa con tu entrenamiento.',
    image: '/assets/redesign/learning-cards/routine.png',
    destination: 'routine',
  },
  {
    id: 'recordings',
    title: 'Dropbox-Grabaciones',
    description: 'Ten acceso a todas tus grabaciones.',
    unavailableDescription:
      'Las grabaciones estarán disponibles cuando se configure tu enlace.',
    image: '/assets/redesign/learning-cards/recordings.png',
    destination: 'dropbox',
  },
  {
    id: 'chat',
    title: 'Chat con profesores',
    description: 'Habla con tus profesores.',
    unavailableDescription: 'El chat con profesores estará disponible pronto.',
    image: '/assets/redesign/learning-cards/chat.png',
    destination: 'chat',
  },
]
